import React from 'react';

export default function PerusahaanJepang() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Perusahaan Jepang</h1>
      <p className="text-gray-500">Halaman Perusahaan Jepang</p>
    </div>
  );
}
